/** Regole upload immagini collezione — allineate a mp-be `app.upload.logo-image`. */
export const COLLECTION_IMAGE_MAX_COUNT = 3;
export const COLLECTION_IMAGE_MAX_SIZE_BYTES = 2 * 1024 * 1024;
export const COLLECTION_IMAGE_MAX_SIZE_LABEL = '2MB';

export const COLLECTION_IMAGE_ALLOWED_MIME_TYPES = new Set([
  'image/png',
  'image/jpeg',
  'image/webp',
]);

export const COLLECTION_IMAGE_ALLOWED_EXTENSIONS = new Set([
  '.png',
  '.jpg',
  '.jpeg',
  '.webp',
]);

export const COLLECTION_IMAGE_ACCEPT = '.jpg,.jpeg,.png,.webp';

export interface CollectionImageValidationResult {
  valid: File[];
  invalidTypes: string[];
  invalidSizes: string[];
}

function fileExtension(name: string): string {
  const dot = name.lastIndexOf('.');
  if (dot < 0) return '';
  return name.slice(dot).toLowerCase();
}

/** Verifica tipo file (mime + fallback estensione). */
export function isAllowedCollectionImageType(file: File): boolean {
  const mime = file.type?.trim().toLowerCase();
  if (mime && COLLECTION_IMAGE_ALLOWED_MIME_TYPES.has(mime)) {
    return true;
  }
  return COLLECTION_IMAGE_ALLOWED_EXTENSIONS.has(fileExtension(file.name));
}

/** Filtra file per tipo e dimensione massima. */
export function validateCollectionImageFiles(files: File[]): CollectionImageValidationResult {
  const valid: File[] = [];
  const invalidTypes: string[] = [];
  const invalidSizes: string[] = [];

  for (const file of files) {
    if (!isAllowedCollectionImageType(file)) {
      invalidTypes.push(file.name);
      continue;
    }
    if (file.size > COLLECTION_IMAGE_MAX_SIZE_BYTES) {
      invalidSizes.push(file.name);
      continue;
    }
    valid.push(file);
  }

  return { valid, invalidTypes, invalidSizes };
}

export function collectionImageTypeErrorMessage(fileNames: string[]): string {
  return `Formato non supportato (${fileNames.join(', ')}). Formati consentiti: PNG, JPEG, WEBP`;
}

export function collectionImageSizeErrorMessage(fileNames: string[]): string {
  return `Dimensione massima superata (${fileNames.join(', ')}): ${COLLECTION_IMAGE_MAX_SIZE_LABEL}`;
}
